import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Popover } from 'antd';
import sentGAEvent from '@/ga';
import Utils from '@/utils';
import { ReactComponent as CutIcon } from '@/assets/icons/cut.svg';
import { ReactComponent as SpeedIcon } from '@/assets/icons/speed.svg';
import { ReactComponent as AddWatermarkIcon } from '@/assets/icons/add-watermark.svg';
import { ReactComponent as CropRotateIcon } from '@/assets/icons/crop-rotate.svg';
import { ReactComponent as ResizeIcon } from '@/assets/icons/resize.svg';
import { ReactComponent as AddMusicIcon } from '@/assets/icons/add-music.svg';
import { ReactComponent as SubtitleIcon } from '@/assets/icons/subtitle.svg';
import { ReactComponent as MergeIcon } from '@/assets/icons/merge.svg';
import { ReactComponent as RemoveWatermarkIcon } from '@/assets/icons/water-remover.svg';
import { ReactComponent as MuteIcon } from '@/assets/icons/mute.svg';
import { ReactComponent as MoreIcon } from '@/assets/icons/more.svg';
import Device from 'current-device';
import '@/assets/convert.less';

const ConvertWorkFooterRender = ({
  convertBtnDisabled,
  isConverted,
  requstConvert,
  handleContinue,
  handleDownloadAll,
  isHideFooter,
  type,
}) => {
  const { t } = useTranslation(['convert']);
  const content = (
    <div className='menu-more'>
      <div className='menu-item' onClick={() => handleContinue('crop_rotate')}>
        <CropRotateIcon /> {t('Crop & Rotate')}
      </div>
      <div className='menu-item' onClick={() => handleContinue('resize')}>
        <ResizeIcon /> {t('Resize')}
      </div>
      <div className='menu-item' onClick={() => handleContinue('addMusic')}>
        <AddMusicIcon /> {t('Add Music')}
      </div>
      <div className='menu-item' onClick={() => handleContinue('subtitle')}>
        <SubtitleIcon /> {t('Subtitles')}
      </div>
      <div className='menu-item' onClick={() => handleContinue('merge')}>
        <MergeIcon /> {t('Merge')}
      </div>
      <div
        className='menu-item'
        onClick={() => handleContinue('removeWatermark')}
      >
        <RemoveWatermarkIcon /> {t('Watermark Remover')}
      </div>
    </div>
  );
  const downWhat = (val) => {
    console.log('lkdfjsldkfjlskdjflsdjkf', val);
    if (val == 'Desktop') {
      sentGAEvent({
        category: 'Download',
        action: 'ToolkitDownload',
        label: 'convertsuccess',
      });
      window.location.href = Utils.getHitPawConvertLink();
    } else {
      let action;
      if (type === 'image') {
        action = '34IC_DownloadStart';
      } else if (type === 'audio') {
        action = '29AC_DownloadStart';
      } else {
        action = '36VC_DownloadStart';
      }
      if (action) {
        sentGAEvent({
          category: 'DownloadStart',
          action: action,
          label: 'Null',
        });
      }
      handleDownloadAll();
    }
  };
  return (
    <div className='footer'>
      {isConverted ? (
        <div className='continue-menu'>
          {/* <div className='btn-group'> */}
          {/* <Button
            type='primary'
            size='large'
            onClick={() => {
              sentGAEvent({
                category: 'Download',
                action: 'ToolkitDownload',
                label: 'convertsuccess',
              });
            }}
            href={Utils.getHitPawToolKitEXELink()}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('Download Desktop')}
          </Button>
          <Button type='primary' ghost size='large' onClick={handleDownloadAll}>
            {t('Download All')}
          </Button> */}
          {Device.mobile() ? (
            <div className='btn-group'>
              <div className='desk' onClick={() => downWhat('ALL')}>
                {t('Download All')}
              </div>
            </div>
          ) : (
            <div className='btn-group'>
              <div className='desk' onClick={() => downWhat('Desktop')}>
                {t('Download Desktop')}
              </div>
              <div className='all' onClick={() => downWhat('ALL')}>
                {t('Download All')}
              </div>
            </div>
          )}
          {/* </div> */}
          {!isHideFooter() && (
            <div>
              <p>{t('Continue Editing')}:</p>
              <div className='menu'>
                <div
                  className='menu-item'
                  onClick={() => handleContinue('cut')}
                >
                  <CutIcon /> {t('Cut')}
                </div>
                <div
                  className='menu-item'
                  onClick={() => handleContinue('speed')}
                >
                  <SpeedIcon /> {t('Speed')}
                </div>
                <div
                  className='menu-item'
                  onClick={() => handleContinue('mute')}
                >
                  <MuteIcon /> {t('Extract')}
                </div>
                <div
                  className='menu-item'
                  onClick={() => handleContinue('addWatermark')}
                >
                  <AddWatermarkIcon /> {t('Add Watermark')}
                </div>
                {/* mouseLeaveDelay={20000} */}
                <Popover
                  className='more-popover'
                  placement='topRight'
                  content={content}
                >
                  <MoreIcon className='more' />
                </Popover>
              </div>
            </div>
          )}
        </div>
      ) : (
        <Button
          className='save-btn'
          disabled={convertBtnDisabled}
          type='primary'
          size='large'
          onClick={requstConvert}
        >
          {convertBtnDisabled ? t('Converting') : t('Convert')}
        </Button>
      )}
    </div>
  );
};

export default ConvertWorkFooterRender;
